"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/libs/auth");
var _layout = _interopRequireDefault(require("@/layout"));
var _parentView = _interopRequireDefault(require("@/views/parent-view"));
var _getTitle = require("./libs/getTitle.js");
// progress bar
// progress bar style

// get token from cookie

var _import = require("./router/_import_" + process.env.NODE_ENV); // 获取组件的方法
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/newsDetail", "/", "/auth-redirect", "/reNews", "/professionalTeaching", "/professionalTeachingCourse", "/boutiqueCourse", "/virtualCourse", "/numberTextbook", '/register', '/registerEdit', '/teacherMatch', '/teacherIndex', '/teacherNews', '/teacherNewsDetail', '/yearView', '/yearViewDetail', '/hisWorks', '/competition', "/books", "/virtual", "/allModule", "/teacherPower", "/deYu", "/tiYu", "/meiYu", "/characteristics", "/userService", '/userServiceTwo', '/characteristic', "/learning", "/communityEducation", '/oldAgeEducation', "/collegeEngineers", "/courseSearch", "/semanticSearch", "/bjlogin", '/majorSource', '/onlineCourse', '/fictitiousCourse', '/openCourse', '/teachingMaterial', '/recommendCourse', '/courseDetail',
// 国际专区路由 — 允许匿名访问（公开展示页面）
'/international', '/international/home', '/international/news', '/international/newsDetail', '/international/courses', '/international/courseDetail', '/international/courseLearn', '/international/about'];

//获取院校code,设置白名单
var v = window.location.hostname;
_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _nprogress.default.start();
          // document.title = getPageTitle(to.meta.title)
          hasToken = (0, _auth.getToken)();
          if (hasToken) {
            if (to.path === "/") {
              next();
              _nprogress.default.done();
            } else {
              // 获取用户角色
              hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
              if (hasRoles) {
                next();
              } else {
                next();

                // try {
                //   // 获取用户角色信息
                //   await store.dispatch("user/getInfo");
                //   // 获取用户菜单和路由权限信息
                //   await store.dispatch("permission/loadMenu");
                //   // 过滤路由
                //   const accessRoutes = filterAsyncRouter(store.getters.sidebarRouters);
                //   // 添加动态路由
                //   router.addRoutes(accessRoutes);
                //   // 保存路由
                //   store.commit("permission/SET_ROUTES", accessRoutes);
                //   next({
                //     ...to,
                //     replace: true
                //   });
                //   // }
                // } catch (error) {
                //   console.log(error);
                //   next(`/`);
                //   NProgress.done();
                // }
              }
            }
          } else {
            if (whiteList.indexOf(to.path) !== -1) {
              next();
            } else {
              next("/");
              // next();
              _nprogress.default.done();
            }
          }
          document.title = "".concat(to.meta.title);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  var accessedRouters = asyncRouterMap.filter(function (route) {
    if (route.component) {
      if (route.component === "Layout") {
        route.component = _layout.default;
      } else if (route.component === "ParentView") {
        route.component = _parentView.default;
      } else {
        route.component = _import(route.component); // 导入组件
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });
  return accessedRouters;
}